export default "__VITE_PUBLIC_ASSET__0bf569c6__"